class APIS {
    apis() {
        return {
            get_profile: {
                headers: {
                    'xt-user-token': null,
                },
                method: 'get',
                path: '/backend/user/attribute',
            },
            update: {
                headers: {
                    'xt-user-token': null,
                },
                method: 'put',
                path: '/backend/users/:id/attributes',
            },
            meta_profile: {
                headers: {
                    'xt-user-token': null,
                },
                method: 'post',
                path: '/client/meta',
            },
            get_profile_data: {
                headers: {
                    'xt-user-token': null,
                },
                method: 'post',
                path: '/get-profile/meta',
            },
            update_profile_data: {
                headers: {
                    'xt-user-token': null,
                },
                method: 'post',
                path: '/update-profile/meta',
            },
            apply_oba: {
                headers: {
                    'xt-user-token': null,
                },
                method: 'post',
                path: '/apply-oba',
            },
            meta_messaging_limit: {
                headers: {
                    'xt-user-token': null,
                },
                method: 'post',
                path: '/backend/users/meta-messaging-limit',
            },
        };
    }
}

export default new APIS();
